import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ListTodo, User } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtDue = (d) => {
  if (!d) return 'Not scheduled';
  const dt = new Date(d);
  return isNaN(dt) ? d : dt.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
};

export const HiveOpenTasks = ({ hiveId }) => {
  const [tasks, setTasks] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('crewToken') || localStorage.getItem('token');
    const load = () => axios.get(`${API}/hives/${hiveId}/open-tasks`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setTasks(res.data.tasks || []))
      .catch(() => setTasks([]));
    load();
    window.addEventListener('refreshData', load);
    return () => window.removeEventListener('refreshData', load);
  }, [hiveId]);

  if (tasks === null) return null;

  return (
    <div data-testid="hive-open-tasks">
      <div className="bg-white rounded-xl border border-stone-200 shadow-sm p-4">
        <h3 className="font-bold text-stone-800 flex items-center gap-2 mb-3">
          <ListTodo className="h-5 w-5 text-amber-600" /> Open Tasks
          <span className="text-xs font-medium text-stone-500 bg-stone-100 rounded-full px-2 py-0.5" data-testid="hive-open-tasks-count">{tasks.length}</span>
        </h3>
        {tasks.length === 0 ? (
          <p className="text-sm text-stone-500" data-testid="hive-open-tasks-empty">No open tasks for this hive.</p>
        ) : (
          <ul className="divide-y divide-stone-100">
            {tasks.map(t => (
              <li key={`${t.source}-${t.id}`} className="py-2 flex items-start justify-between gap-3" data-testid={`hive-open-task-${t.id}`}>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-stone-800 break-words">{t.title}</p>
                  {t.assignee && <p className="text-xs text-stone-500 flex items-center gap-1 mt-0.5"><User className="h-3 w-3" />{t.assignee}</p>}
                </div>
                <span className={`text-xs whitespace-nowrap rounded-full px-2 py-0.5 ${t.priority === 'critical' ? 'bg-red-100 text-red-700' : 'bg-amber-50 text-amber-700'}`}>{fmtDue(t.due)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default HiveOpenTasks;
